const { exceptionHandler } = require("./utils")
const { setPlatformConfig } = require("./config")
const { nativeBridge, webBridge } = require("./bridge")

const synapse = {
    initialize: (config) => {
        const platformConfig = setPlatformConfig(config)
        if (config.nativeBridge) {
            exceptionHandler(nativeBridge.initialize(platformConfig.nativeBridge))
        }
        if (config.webBridge) {
            exceptionHandler(webBridge.initialize(platformConfig.webBridge))
        }
    },
    webBridge: { register: exceptionHandler(webBridge.register) },
}

module.exports = synapse
